<template>
  <div>
    <cx-check-box :value.sync="showRadiusAxis">显示横轴</cx-check-box>
    <div v-if="showRadiusAxis && checkType(showRadiusAxis)">
      <p class="font14 mb16 mt16">横轴文字</p>
      <div v-if="barColorType === 'single'">
        <!-- 字体和颜色 -->
        <!--字重和字号 -->
        <text-setting-update
          v-if="
            checkType(radiusAxisFontColor) ||
            checkType(radiusAxisFontFamily) ||
            checkType(radiusAxisFontSize) ||
            checkType(radiusAxisFontWeight)
          "
          class="mt8"
          colorMode="chart"
          :fontColor.sync="radiusAxisFontColor"
          :fontFamily.sync="radiusAxisFontFamily"
          :fontSize.sync="radiusAxisFontSize"
          :fontWeight.sync="radiusAxisFontWeight"
        />
        <!--轴线文本旋转-->
        <div class="mt16" v-if="checkType(radiusAxisLabelRotate)">
          <slider-and-input
            v-if="checkType(radiusAxisLabelRotate)"
            class="mt8"
            :value.sync="radiusAxisLabelRotate"
            title="旋转"
            :sliderMax="sliderMax"
            suffix="度"
          />
        </div>

        <div class="mt16" v-if="checkType(showRadiusAxisUnit)">
          <cx-check-box :value.sync="showRadiusAxisUnit">显示单位</cx-check-box>
          <div class="mt16" v-if="showRadiusAxisUnit">
            <span class="font14 mr10 half-label">单位文本</span>
            <el-input
              class="width-half-bigWidth el-input el-input--suffix"
              placeholder="请输入"
              v-model="showRadiusAxisUnitValue"
            >
            </el-input>
          </div>
          <!-- 字体和颜色 -->
          <!--字重和字号 -->
          <text-setting-update
            class="mt8"
            colorMode="chart"
            :fontColor.sync="radiusAxisUnitValueFontColor"
            :fontFamily.sync="radiusAxisUnitValueFontFamily"
            :fontSize.sync="radiusAxisUnitValueFontSize"
            :fontWeight.sync="radiusAxisUnitValueFontWeight"
          />
        </div>

        <!-- <div class="mt16"> -->
        <line-setting
          v-if="checkType(radiusAxisLineType) || checkType(radiusAxisLineWidth) || checkType(radiusAxisLabelColor)"
          class="mt16"
          title="轴线样式"
          :lineName.sync="radiusAxisLineType"
          :lineWidth.sync="radiusAxisLineWidth"
          :lineColor.sync="radiusAxisLabelColor"
          suffix="px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      barColorType: "single"
    }
  },
  methods: {
    changeColorType(flag) {
      this.barColorType = flag
    },
    checkFormatterValue() {
      if (!this.chartOpt.radiusAxis.axisLabel.formatter) {
        this.$changeOptionsEV("{value}{valueUnit| }", "chartOption.radiusAxis.axisLabel.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.radiusAxis.axisLabel.rich",
          false
        )
      }
    }
  },
  computed: {
    chartOpt() {
      return this.options.chartOption
    },
    showRadiusAxisUnitValue: {
      get() {
        return this.chartOpt.radiusAxis.name
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.name", false)
      }
    },
    showRadiusAxisUnit: {
      get() {
        return !!this.chartOpt.radiusAxis.name.length
      },
      set(newVal) {
        if (newVal) {
          this.$changeOptionsEV(" ", "chartOption.radiusAxis.name", false)
        } else {
          this.$changeOptionsEV("", "chartOption.radiusAxis.name", false)
        }
      }
    },
    radiusAxisUnitValueFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radiusAxis.nameTextStyle.fontFamily", "radiusAxisUnitValueFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.nameTextStyle.fontFamily", false)
      }
    },
    radiusAxisUnitValueFontSize: {
      get() {
        return this.chartOpt.radiusAxis.nameTextStyle.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.nameTextStyle.fontSize", false)
      }
    },
    radiusAxisUnitValueFontWeight: {
      get() {
        return this.chartOpt.radiusAxis.nameTextStyle.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.nameTextStyle.fontWeight", false)
      }
    },
    radiusAxisUnitValueFontColor: {
      get() {
        return this.chartOpt.radiusAxis.nameTextStyle.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.nameTextStyle.color", false)
      }
    },
    showRadiusAxis: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.show", false)
      }
    },
    radiusAxisFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radiusAxis.axisLabel.fontFamily", "radiusAxisFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLabel.fontFamily", false)
      }
    },
    radiusAxisFontColor: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.axisLabel.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLabel.color", false)
      }
    },
    radiusAxisFontWeight: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.axisLabel.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLabel.fontWeight", false)
      }
    },
    radiusAxisFontSize: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.axisLabel.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLabel.fontSize", false)
      }
    },
    radiusAxisLabelColor: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.axisLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLine.lineStyle.color", false)
      }
    },
    radiusAxisLineType: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.axisLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLine.lineStyle.type", false)
      }
    },
    radiusAxisLineWidth: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.axisLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLine.lineStyle.width", false)
      }
    },
    radiusAxisLabelRotate: {
      get() {
        return this.hasProperty(this.chartOpt, "radiusAxis.axisLabel.rotate")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radiusAxis.axisLabel.rotate", false)
      }
    }
  }
}
</script>

<style scoped>
.number-input-boxAround {
  align-items: normal;
}
::v-deep .el-select {
  margin-bottom: 0px;
}

.bar-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.bar-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
</style>
